import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseDto } from '../../../shared/modules/base/dtos/base.dto';

import { PlatformSettingsNotificationsDto } from './platform-settings-notifications.dto';

/**
 * Platform Settings DTO
 */
@CaslSubject(AppSubjectEnum.PLATFORM_SETTINGS)
export class PlatformSettingsDto extends BaseDto {
  meteringStartsAt?: string;
  notifications?: PlatformSettingsNotificationsDto;
}
